export default {
  MAGIC_LINK_REPOSITORY: Symbol.for('MAGIC_LINK_REPOSITORY'),
  VERIFY_TOKEN_MAGIC_LINK_QUERY: Symbol.for('VERIFY_TOKEN_MAGIC_LINK_QUERY'),
};
